import { NgModule, ModuleWithProviders } from '@angular/core'

import { AuthService } from './auth.service'
import { AuthGuard } from './auth-guard'
import { FacebookProviderData } from './facebook-provider-data.model'

@NgModule({})
export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        AuthGuard
      ]
    }
  }
}

export { AuthService, AuthGuard, FacebookProviderData }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/auth/auth.module.ts